// Must be the FIRST import of the app entry (main.jsx). ES import declarations
// are hoisted and evaluated before any sibling statement runs, so assigning
// window.Buffer inside main.jsx itself would execute AFTER the web3.js / Privy
// module bodies have already evaluated. Isolating the polyfill in its own module
// and importing it first guarantees the global exists before those load.
import { Buffer } from 'buffer/'
window.Buffer = Buffer
